function Status({ text }) {
    return <div className={text === "Approved" ? "text-success" : "text-secondary"}>{text}</div>
}

export default Status;